export default {
  store   : 'USD',
  current : 'USD',
  currencies: Object.assign([], window._data.frontend_currencies),
}
